/*
 * Free gift with TwinTec S4: keeps the cart in step with the offer.
 *
 * - TwinTec S4 in the cart, no gift      -> adds 1 gift (the automatic discount makes it free)
 * - TwinTec S4 in the cart, gift qty > 1 -> sets the gift back to 1
 * - Gift in the cart, no TwinTec S4      -> leaves it, so the cart page can explain and block checkout
 * - Customer removes the gift            -> marks the cart "Declined by customer" and doesn't add it again
 *                                           (the cart page offers an "Add the free salt back" button)
 *
 * Runs on page load and whenever Debut updates the cart count in the header
 * (after an ajax add to cart, or a quantity change on the cart page).
 * Config comes from snippets/free-gift-script.liquid as window.FreeGift.
 */
(function () {
  'use strict';

  var cfg = window.FreeGift;
  if (!cfg || !window.fetch) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var running = false;
  var queued = false;
  var debounceTimer = null;

  function cartRequest(path, body) {
    return fetch(root + path, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (res) {
      if (!res.ok) throw new Error('Free gift: ' + path + ' returned ' + res.status);
      return res.json();
    });
  }

  function summarise(cart) {
    var triggerQty = 0;
    var giftQty = 0;
    cart.items.forEach(function (item) {
      if (cfg.triggerProductIds.indexOf(item.product_id) !== -1) triggerQty += item.quantity;
      if (item.variant_id === cfg.giftVariantId) giftQty += item.quantity;
    });
    var status = (cart.attributes && cart.attributes[cfg.attribute]) || '';
    return { triggerQty: triggerQty, giftQty: giftQty, status: status };
  }

  // Records the customer's choice on the cart (and later the order).
  function setStatus(value) {
    var attributes = {};
    attributes[cfg.attribute] = value;
    return cartRequest('cart/update.js', { attributes: attributes });
  }

  function addGift() {
    return cartRequest('cart/add.js', { items: [{ id: cfg.giftVariantId, quantity: 1 }] })
      .then(function () { return setStatus(cfg.added); });
  }

  // Returns a promise that resolves to true if the change should be visible to the customer.
  function fixCart(state) {
    var updates;
    if (state.triggerQty > 0 && state.giftQty === 0) {
      // The customer said no to the gift in this cart: leave it out.
      if (state.status === cfg.declined) return Promise.resolve(false);
      // The gift was added before and is now gone, so the customer removed it.
      if (state.status === cfg.added) {
        return setStatus(cfg.declined).then(function () { return true; });
      }
      return addGift().then(function () { return true; });
    }
    if (state.triggerQty > 0 && state.giftQty > 1) {
      updates = {};
      updates[cfg.giftVariantId] = 1;
      return cartRequest('cart/update.js', { updates: updates })
        .then(function () { return true; });
    }
    if (state.triggerQty > 0 && state.giftQty > 0 && state.status !== cfg.added) {
      return setStatus(cfg.added).then(function () { return false; });
    }
    // The cart no longer has a softener or the gift: start fresh and offer the gift again next time.
    if (state.triggerQty === 0 && state.giftQty === 0 && state.status !== '') {
      return setStatus('').then(function () { return false; });
    }
    return Promise.resolve(false);
  }

  function updateHeaderCount(cart) {
    var counts = document.querySelectorAll('[data-cart-count]');
    var bubbles = document.querySelectorAll('[data-cart-count-bubble]');
    Array.prototype.forEach.call(counts, function (el) {
      if (el.textContent !== String(cart.item_count)) el.textContent = cart.item_count;
    });
    Array.prototype.forEach.call(bubbles, function (el) {
      el.classList.toggle('hide', cart.item_count === 0);
    });
  }

  function cartPageIsStale(state) {
    // The blocked message is rendered by Liquid; reload if it no longer matches the cart.
    var shownBlocked = !!document.querySelector('[data-free-gift-blocked]');
    var isBlocked = state.giftQty > 0 && state.triggerQty === 0;
    return shownBlocked !== isBlocked;
  }

  // Never reload the cart page more than once in a few seconds, whatever happens.
  function reloadOnce() {
    var key = 'freeGiftReloadedAt';
    var last = 0;
    try { last = Number(sessionStorage.getItem(key)) || 0; } catch (e) {}
    if (Date.now() - last < 3000) return;
    try { sessionStorage.setItem(key, String(Date.now())); } catch (e) {}
    window.location.reload();
  }

  // reason: 'load' when the page has just been rendered, 'change' when Debut changed the cart without a reload.
  function sync(reason) {
    if (running) { queued = true; return; }
    running = true;

    cartRequest('cart.js')
      .then(function (cart) {
        return fixCart(summarise(cart)).then(function (changed) {
          return changed ? cartRequest('cart.js').then(function (fresh) {
            return { cart: fresh, changed: true };
          }) : { cart: cart, changed: false };
        });
      })
      .then(function (result) {
        // A freshly loaded page already matches the cart, so only check for a stale page after an ajax change.
        var stale = reason === 'change' && cartPageIsStale(summarise(result.cart));
        if (cfg.isCartPage && (result.changed || stale)) {
          reloadOnce();
          return;
        }
        if (result.changed) updateHeaderCount(result.cart);
      })
      .catch(function (err) {
        // For example the gift is out of stock. Log it and leave the cart alone.
        if (window.console) console.warn(err);
      })
      .then(function () {
        running = false;
        if (queued) { queued = false; sync('change'); }
      });
  }

  function scheduleSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () { sync('change'); }, 300);
  }

  function watchHeaderCart() {
    var target = document.querySelector('.site-header__cart') || document.querySelector('[data-cart-count-bubble]');
    if (!target || !window.MutationObserver) return;
    new MutationObserver(scheduleSync).observe(target, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true
    });
  }

  // "Add the free salt back" button on the cart page.
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-free-gift-readd]');
    if (!button) return;
    event.preventDefault();
    button.disabled = true;
    addGift()
      .then(function () { window.location.reload(); })
      .catch(function (err) {
        button.disabled = false;
        if (window.console) console.warn(err);
      });
  });

  // "Buy it now" on the TwinTec S4 page: go straight to checkout with the S4 and the free salt.
  // A cart link (/cart/VARIANT:QTY,VARIANT:QTY) creates a checkout with just these items,
  // like Shopify's own Buy it now, and leaves the customer's cart as it is.
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-free-gift-buy-now]');
    if (!button) return;
    event.preventDefault();

    var form = button.closest('form');
    var error = form && form.querySelector('[data-free-gift-buy-now-error]');
    var variantInput = form && form.querySelector('[name="id"]');
    var quantityInput = form && form.querySelector('[name="quantity"]');
    var addButton = form && form.querySelector('[data-add-to-cart]');
    var variantId = variantInput && variantInput.value;
    var quantity = Math.max(1, parseInt(quantityInput && quantityInput.value, 10) || 1);

    function showError(message) {
      if (!error) return;
      error.textContent = message;
      error.hidden = false;
    }

    if (!variantId) {
      showError('Please choose an option first.');
      return;
    }
    if (addButton && addButton.getAttribute('aria-disabled') === 'true') {
      showError('This option is sold out.');
      return;
    }

    var attributeKey = encodeURIComponent('attributes[' + cfg.attribute + ']');
    window.location.href = root + 'cart/' + variantId + ':' + quantity + ',' + cfg.giftVariantId + ':1' +
      '?' + attributeKey + '=' + encodeURIComponent(cfg.added);
  });

  watchHeaderCart();
  sync('load');
})();
